// extracted by mini-css-extract-plugin
module.exports = {"root":"a4vbXq","title":"jrMolP","hint":"NgTiIv","value":"k1YWFc","shake":"iQc9a1","valueDigit":"kGOpTw","keyboard":"-xm0yd","key":"rIjd1m","erase":"+yZ69y"};